<template>
  <div class="be-splash-screen">
    <div class="be-wrapper be-login">
      <div class="be-content">
        <div class="main-content container-fluid">
          <div class="splash-container">
            <div class="card card-border-color card-border-color-primary">
              <div class="card-header">
                <img
                  class="w-auto h-20 w-full object-contain"
                  src="/assets/img/uac-logo.png"
                  alt="logo"
                />
                <h4>Link Your Account</h4>
                <span class="splash-description"
                  >Please enter your user information to link your
                  account.</span
                >
              </div>
              <div class="card-body">
                <form>
                  <div class="form-group">
                    <input
                      :class="[
                        'form-control',
                        { 'is-invalid': $v.user.username.$error },
                      ]"
                      id="username"
                      type="text"
                      placeholder="Username"
                      autocomplete="off"
                      v-model.trim="$v.user.username.$model"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="
                        !$v.user.username.required && $v.user.username.$dirty
                      "
                    >
                      Field is required.
                    </div>
                    <div
                      class="invalid-feedback"
                      v-if="!$v.user.username.alphaNumAndDotValidator"
                    >
                      Username must not include space or special characters!
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      :class="[
                        'form-control',
                        { 'is-invalid': $v.user.displayName.$error },
                      ]"
                      type="text"
                      placeholder="Name"
                      v-model.trim="$v.user.displayName.$model"
                    />
                    <ul
                      v-if="
                        !$v.user.displayName.required &&
                          $v.user.displayName.$dirty
                      "
                      class="parsley-errors-list filled"
                    >
                      <li class="parsley-required">Required.</li>
                    </ul>
                  </div>
                  <div class="form-group">
                    <input
                      :class="[
                        'form-control',
                        { 'is-invalid': $v.user.emailAddress.$error },
                      ]"
                      type="text"
                      v-model.trim="$v.user.emailAddress.$model"
                      readonly
                      placeholder="Email Address"
                    />
                    <ul
                      v-if="
                        !$v.user.emailAddress.required &&
                          $v.user.emailAddress.$dirty
                      "
                      class="parsley-errors-list filled"
                    >
                      <li class="parsley-required">Required.</li>
                    </ul>
                    <ul
                      v-if="!$v.user.emailAddress.email"
                      class="parsley-errors-list filled"
                    >
                      <li class="parsley-required">
                        Enter a valid email address.
                      </li>
                    </ul>
                  </div>
                  <div class="form-group">
                    <input
                      class="form-control"
                      type="text"
                      v-model.trim="user.phoneNumber"
                      readonly
                      placeholder="Phone Number"
                    />
                  </div>
                  <div class="form-group">
                    <textarea
                      :class="[
                        'form-control',
                        { 'is-invalid': $v.user.deliveryAddress.$error },
                      ]"
                      placeholder="Delivery Address"
                      v-model.trim="$v.user.deliveryAddress.$model"
                    ></textarea>
                    <ul
                      v-if="
                        !$v.user.deliveryAddress.required &&
                          $v.user.deliveryAddress.$dirty
                      "
                      class="parsley-errors-list filled"
                    >
                      <li class="parsley-required">Required.</li>
                    </ul>
                  </div>
                  <div class="form-group">
                    <input
                      :class="[
                        'form-control',
                        { 'is-invalid': $v.user.password.$error },
                      ]"
                      type="password"
                      v-model.trim="$v.user.password.$model"
                      placeholder="Password"
                    />
                    <ul
                      v-if="
                        !$v.user.password.required && $v.user.password.$dirty
                      "
                      class="parsley-errors-list filled"
                    >
                      <li class="parsley-required">Required.</li>
                    </ul>
                    <ul
                      v-if="!$v.user.password.minLength"
                      class="parsley-errors-list filled"
                    >
                      <li class="parsley-required">
                        Enter a password greater than or equal to 6 characters.
                      </li>
                    </ul>
                  </div>
                  <div class="form-group login-submit">
                    <button
                      :disabled="isBusy"
                      class="btn btn-primary"
                      @click.prevent="update"
                    >
                      <span v-if="isBusy">Busy...</span>
                      <span v-else>Create account</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { helper } from "@/helper";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";

const alphaNumAndDotValidator = helpers.regex("alphaNumAndDot", /^[a-z\d.]*$/i);

export default {
  name: "linkAccount",
  created() {
    this.getUser();
  },
  data() {
    return {
      isBusy: false,
      user: {
        id: "",
        username: "",
        displayName: "",
        emailAddress: "",
        phoneNumber: "",
        password: "",
        deliveryAddress: "",
      },
    };
  },
  validations: {
    user: {
      username: { required, alphaNumAndDotValidator },
      displayName: { required },
      emailAddress: { required, email },
      password: { required, minLength: minLength(6) },
      deliveryAddress: { required },
    },
  },

  methods: {
    getUser() {
      try {
        let json = helper.decodeString(this.$route.params.token);

        this.user = JSON.parse(json);
      } catch (err) {
        this.$router.push("/login");
      }
    },
    async update() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isBusy = true;

        await this.$http
          .put("/Users/linkAccount/" + this.user.id, this.user)
          .then(function(res) {
            $.gritter.add({
              title: "Account Linked",
              text:
                "Your user account has been linked. You can now login with your username and password.",
              class_name: "color success",
            });

            this.$router.push("/login");
          })
          .catch(function() {});

        this.isBusy = false;
      }
    },
  },
};
</script>
